module.exports = __webpack_public_path__ + "img/hot.9b313be1.png";